import type {MultiThesaurusValue} from 'sceneExtensions/extensions/multiThesaurusEdit/types';
import type {ThesaurusId} from 'services/thesaurus/types';
import type {MultiEditValue, MultiThesaurusMaps} from '../types';
import {mapThesaurusValueToNodeIds} from '../../editThesaurus/functions';

export const mapMultiThesaurusValueToNodeIds = (
  thesaurusIds: ThesaurusId[],
  values: MultiThesaurusValue,
  maps: MultiThesaurusMaps,
) => {
  return thesaurusIds.reduce<MultiEditValue>(
    (acc, id) => ({
      ...acc,
      [id]: mapThesaurusValueToNodeIds(values[id], maps[id]!.codeToIds),
    }),
    {},
  );
};
